import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { CallDialogComponent } from './call-dialog.component';
import { TranslationIdMap } from './call-dialog.i18n';

@NgModule({
    declarations: [CallDialogComponent],
    exports: [CallDialogComponent],
    imports: [
        CmpsButtonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
})
export class CmpsTeamsCallCallDialogModule {}
